<template>
    <div>
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" :height="150" :width="150"
            :color="'#FFFF00'" :background-color="'#000000'" :opacity="0.5"></loading>

        <app-form v-if="!isLoading" v-bind:parentObject="{
            data: this.formData,
            pageTitle: this.pageTitle,
            isEdit: this.isEdit,
        }" v-on:input="formData = $event" v-on:save="saveHandler" v-on:error="errorHandler" />
        <div v-if="isErr">
            <app-error v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }" v-on:closeError="isErr = $event" />
        </div>
    </div>
</template>

<script>
import acknowledgementForm from "../../../components/settings/acknowledgement/Form";
import Loading from "vue-loading-overlay";
import ErrorDialog from "../../../components/common/ErrorDialog";
import moment from "moment";

export default {
    components: {
        "app-form": acknowledgementForm,
        "app-error": ErrorDialog,
        Loading,
    },

    data() {
        return {
            pageTitle: this.$t('acknowledgement.editacknowledgement'),
            formData: {
                id: this.$route.params.id,
                ackTypeId: null,
                ackName: null,
                ackLongDesc: null,
                createDate: null,
                publishDate: null,
                suspendStatus: null,
                content: null,
                remark: null,
                attach: null,
                attachname: null,
                detailItemList: [],
                stamp: null,
                updatedby: null,
            },

            errMsg: "",
            isErr: false,
            isEdit: true,
            isLoading: false,
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        saveHandler() {
            const vm = this;
            if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                console.error("cannot edit");
                vm.isErr = true;
                vm.errMsg = "No permission to edit record";
                return;
            }
            // console.log("form data to be saved in Edit", this.formData);
            this.$store.dispatch('put', { url: `/acknowledgement/${this.formData.id}`, payload: this.formData })
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;

                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        this.$router.push({ name: "acknowledgementgrid" });
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
        },

        async loadAcknowledgement() {
            const vm = this;
            if (this.formData.id === null || this.formData.id === undefined) {
                vm.isErr = true;
                vm.errMsg = "Invalid record ID";
                return;
            }
            try {
                const res = await this.$store.dispatch('get', { url: `/acknowledgement/${this.formData.id}` });
                if (res.data.error) {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    return;
                } else {
                    if (res.data === null || res.data === undefined || Object.keys(res.data).length === 0) {
                        vm.isErr = true;
                        vm.errMsg = "Record not found";
                        return;
                    }
                    vm.formData = res.data.rec[0]; // Assuming the API returns an object with a 'rec' array
                    vm.formData.createDate = moment(vm.formData.createDate).format("YYYY-MM-DD");
                    vm.formData.publishDate = moment(vm.formData.publishDate).format("YYYY-MM-DD");
                    vm.formData.updatedby = this.$store.getters.userId;//taking current user as updated by
                }
            } catch (error) {
                vm.isErr = true;
                vm.errMsg = error;
            }
        },

        async loadAcknowledgementDetail() {
            const vm = this;
            vm.formData.detailItemList = [];
            if (this.formData.id === null || this.formData.id === undefined) {
                vm.isErr = true;
                vm.errMsg = "Invalid record ID to find detail";
                return;
            }
            try {
                const res = await this.$store.dispatch('get', { url: `/acknowledgementdetail/${this.formData.id}` });
                if (res.data.error) {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    return;
                } else {
                    // console.log("what is res.data.rec",res.data);
                    for (let i = 0; i < res.data.rec.length; i++) {// Assuming the API returns an object with a 'rec' array
                        vm.formData.detailItemList[i] = res.data.rec[i];
                    }
                    // console.log("detail item list",vm.formData.detailItemList);
                }
            } catch (error) {
                vm.isErr = true;
                vm.errMsg = error;
            }
        },
    },
    async mounted() {
        try {
            this.isLoading = true;
            await this.loadAcknowledgement();
            await this.loadAcknowledgementDetail();
            this.isLoading = false;
        }
        catch (error) {
            this.isErr = true;
            this.errMsg = error;
        }
    },
};
</script>